export default __webpack_public_path__ + "static/lets-talk02-7e61ee4ee41f42b320913cbfedbe9f08.png";